import React from 'react';
import { FormControlLabel, Grid, Radio, RadioGroup, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AccountData } from '../../../../../api';
import { useAuth } from '../../../../../session/InternalAuthProvider';
import { useLanguage } from '../../../../../common/GeneralUtils';

export enum PassRedemptionMode {
  Single = 'single',
  Bulk = 'bulk',
}

type PassRedemptionModePanelProps = {
  mode: PassRedemptionMode;
  onModeChange: (mode: PassRedemptionMode) => void;
};

export const PassRedemptionModePanel = ({ mode, onModeChange }: PassRedemptionModePanelProps) => {
  const { t } = useTranslation();
  const { authState } = useAuth();
  const language = useLanguage();
  const account = authState.account as unknown as AccountData;
  const activity = account?.activity_label_singular?.[language] ?? t('passes.activity_fallback_singular');
  const activities = account?.activity_label_plural?.[language] ?? t('passes.activity_fallback_plural');

  return (
    <Grid
      container
      flexDirection="column"
      gap={0.5}
      borderRadius="8px"
      border="1px solid"
      borderColor="divider"
      p={1.5}>
      <Typography fontWeight={700}>{t('passes.redemption_mode')}</Typography>
      <RadioGroup value={mode} onChange={(e) => onModeChange(e.target.value as PassRedemptionMode)}>
        <FormControlLabel
          value={PassRedemptionMode.Single}
          control={<Radio size="small" />}
          label={<Typography variant="body2">{t('passes.redemption_single', { activity })}</Typography>}
        />
        <FormControlLabel
          value={PassRedemptionMode.Bulk}
          control={<Radio size="small" />}
          label={<Typography variant="body2">{t('passes.redemption_bulk', { activities })}</Typography>}
        />
      </RadioGroup>
    </Grid>
  );
};
